import React, { Suspense } from "react";
import { Route } from "react-router-dom";
import { marketsDir } from "./routeUtils"; 

const renderRoutes = (nodes, lang, pagesContext, getComponent, transformString) => {
  const marketBase = `/${lang}/${marketsDir(lang)}`;

  return nodes
    .filter(node => !node.url.startsWith(marketBase))
    .map(node => {
      let label = node.url ? transformString(node.url) : node.label;
      if (node.children?.length > 0) {
        label = `${label}/index`;
      }

      const DynamicPage = getComponent(label, pagesContext);
      return (
        <React.Fragment key={node.databaseId}>
          <Route
            path={node.url}
            element={
              <Suspense fallback={<div>Cargando {node.url}…</div>}>
                <DynamicPage />
              </Suspense>
            }
          />

          {node.children?.length > 0 &&
            renderRoutes(
              node.children,
              lang,
              pagesContext,
              getComponent,
              transformString
            )}
        </React.Fragment>
      );
    });
};

export default renderRoutes;

